export default {
  SET_LIST: (state, payload) => {
    const { data, recordsTotal } = payload
    state.data = data
    state.count = recordsTotal
  },

  SET_LOADING: (state, isLoading) => {
    state.isLoading = isLoading
  },

  UPDATE_LIST: (state, data) => {
    state.data = [...state.data, ...data]
  },

  RESET_LIST: state => {
    const { length } = state.data

    if (length < 101) return

    state.data.splice(100, length)
  },

  LIST_UPDATE_STATUS: (state, { value }) => {
    state.isLoading = value
  }
}
